import { HydraulicProfile, HydraulicProfileDetails, HydraulicProfileResponse, HydraulicProfileUploadData } from './HydraulicProfiler';
import HydraulicProfileRepository from './HydraulicProfilerRepository';

export default class HydraulicProfileService {
  private readonly hydraulicProfileRepository =
    new HydraulicProfileRepository();

  async getAllProfiles(locationId: number): Promise<HydraulicProfile[]> {
    return this.hydraulicProfileRepository.getAllProfiles(locationId);
  }

  async getAllProfilesPagination( page: number, size: number, name?: string, locationId?: number): Promise<HydraulicProfileResponse> {
    return this.hydraulicProfileRepository.getAllProfilesPagination(page, size, name, locationId);
  }

  async getProfileDetails(
    profileId: number,
    startDate: string,
    endDate: string,
  ): Promise<HydraulicProfileDetails | null> {
    return this.hydraulicProfileRepository.getProfileDetails(profileId, startDate, endDate);  
  }

  async deleteProfile(profileId: number): Promise<boolean> {
    return this.hydraulicProfileRepository.deleteProfile(profileId);
  }

  async uploadProfile(profile: HydraulicProfileUploadData): Promise<boolean> {
    return this.hydraulicProfileRepository.uploadProfile(profile);
  }
}
